
<template>
    
        <mars-view class="top-bar-wrapper"><mars-view id="top-bar" class="top-bar" :class="isShowBorder ? 'top-bar-border' : ''" :style="{
            height: barHeight ? barHeight + 'px' : entireHeight + 'px',
            paddingTop: statBarHeight + 'px',
            zIndex: zIndex,
            background: bgColorStr,
        }"><mars-view class="c-row bar" :style="{
                height: navBarHeight + 'px',
            }"><mars-view class="c-span3 bar-left"><mars-view v-if="leftBlockFlag" class="icon leftBlock"></mars-view><c-icon v-else-if="showBackIcon" name="left" font-size="24px" :style="{
                        color: backIconColor || textColor,
                    }" class="icon back" @click.native="leftNavTo('left')"></c-icon><mars-view v-if="showHomeIcon && !showListIcon" name="home" :style="{
                        color: homeIconColor || textColor,
                        fontSize: '22px',
                    }" class="icon iconfont home" @click.native="leftNavTo('home')">
                    
                </mars-view><mars-view v-if="showListIcon" name="list" :style="{
                        color: textColor,
                        fontSize: '24px',
                    }" class="icon iconfont list" @click.native="goRegulationList('home')">
                    
                </mars-view><mars-view v-if="currentCity" class="bar-content-local-info" @click.native="leftNavTo('local')"><mars-view class="bar-content-local-val">{{ handleCityValue }}</mars-view><mars-view class="iconfont"></mars-view></mars-view></mars-view><mars-view v-if="title && titleIcon" :style="{
                    color: textColor,
                }" class="c-span6 title"><template v-if="title === '律临'"><mars-image v-if="titleIcon" :src="titleIcon" class="title-icons-lvlin"></mars-image></template><mars-view v-else class="trusteeship-title-box"><mars-view class="image-box"><mars-image v-if="titleIcon" :src="titleIcon" class="title-icons"></mars-image></mars-view><span v-if="!showTitleIcon">{{ title }}</span></mars-view></mars-view><mars-view v-if="title && !titleIcon" :style="{
                    color: textColor,
                }" class="title"><mars-image v-if="showTitleIcon" src="https://lvlin-base.cdn.bcebos.com/law/common/lvlin-logo.png" class="title-icons-lvlin"></mars-image><span v-if="!showTitleIcon">{{ title }}</span></mars-view><mars-view v-if="logoUrl" class="bar-content-log"><mars-image :src="logoUrl" class="title-icons-lvlin"></mars-image></mars-view><mars-view class="c-span3"><c-menu v-if="!noRightNav && menu && menu.length > 0" :menu="menu"></c-menu></mars-view></mars-view><slot></slot><mars-view v-if="isPreview" class="top-bar-preview" @click.native.stop="goSetPreview">预览机环境</mars-view></mars-view><mars-view v-if="!noBlank" :style="{
            // 兼容部分机型 -1px
            height: barHeight
                ? (barHeight - 1) + 'px'
                : (entireHeight - 1) + 'px',
        }"></mars-view></mars-view>
    
</template>

<script>
import Icon from "../../mars_modules/@baidu/mars-ui/dist/h5/components/Icon/Icon.vue";
import Menu from "./menu.vue";
import { nav } from '../../static/utils/navigate';
import { compareVersion } from '../../static/utils/core';
import { ubcClickInit } from '../../static/utils/ubcMethods.js';
import log from '../../static/utils/ubcLog';
import { checkPreview, LVLIN_PREVIEW_ENV_RECORD } from '../../static/utils/checkPreview';
export default {
  components: {
    'c-icon': Icon,
    'c-menu': Menu
  },
  props: {
    isShowBorder: {
      type: Boolean,
      default: false
    },
    fromPage: {
      type: String,
      default: ''
    },
    // 标题
    title: {
      type: String,
      default: ''
    },
    // 标题icon
    titleIcon: {
      type: String,
      default: ''
    },
    // 高度
    barHeight: {
      type: Number,
      default: 0
    },
    // 文字颜色
    textColor: {
      type: String,
      default: '#fff'
    },
    // 层级
    zIndex: {
      type: Number,
      default: 999
    },
    // 是否不添加占位dom
    noBlank: {
      type: Boolean,
      default: false
    },
    // 插槽高度
    slotHeight: {
      type: Number,
      default: 0
    },
    // 背景颜色 有渐变需传入数组
    bgColor: {
      type: [String, Array],
      default: '#fff'
    },
    // 背景色渐变方向
    bgDirection: {
      type: String,
      default: 'right'
    },
    // 无左侧导航按钮
    noLeftNav: {
      type: Boolean,
      default: false
    },
    // 有无左上交回到首页按钮
    homeFlag: {
      type: Boolean,
      default: false
    },
    // 无右侧导航按钮
    noRightNav: {
      type: Boolean,
      default: false
    },
    // 菜单项
    menu: {
      type: Array,
      default: () => []
    },
    // h5监听返回按钮点击
    listenBack: {
      type: String,
      default: ''
    },
    showTitleIcon: {
      type: Boolean,
      default: false
    },
    // 城市
    currentCity: {
      type: String,
      default: ''
    },
    // logo链接
    logoUrl: {
      type: String,
      default: ''
    },
    // 列表icon
    showListIcon: {
      type: Boolean,
      default: false
    },
    // 不显示返回首页icon
    noShowHome: {
      type: Boolean,
      default: false
    },
    listenHome: {
      type: String,
      default: ''
    },
    // 回退按钮颜色
    backIconColor: {
      type: String,
      default: ''
    },
    homeIconColor: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      statBarHeight: 20,
      navBarHeight: 44,
      entireHeight: 64,
      // leftNavType: '',
      showBackIcon: false,
      leftBlockFlag: false,
      showHomeIcon: false,
      isPreview: false
    };
  },
  computed: {
    bgColorStr() {
      let str = Array.isArray(this.bgColor) ? `linear-gradient(to ${this.bgDirection},${this.bgColor.join()})` : this.bgColor === 'custom' ? 'rgba(255, 255, 255, 0)' : this.bgColor;
      return str;
    },
    handleCityValue() {
      if (this.currentCity.length > 4) {
        return this.currentCity.slice(0, 4) + '...';
      }
      return this.currentCity || '';
    }
  },
  watch: {
    noShowHome: {
      handler(val) {
        this.showHomeIcon = !val;
      },
      immediate: true
    }
  },
  mounted() {
    /* globals getApp, Page, swan, getCurrentPages */
    // 设置bar高度
    let sysinfo = this.$api.getSystemInfoSync();
    let sys = getApp().globalData.system;
    this.statBarHeight = sys.statusBarHeight;
    this.navBarHeight = sys.navigationBarHeight;
    this.entireHeight = this.statBarHeight + this.navBarHeight + this.slotHeight;
    // 设置左侧按钮
    // if (!this.noLeftNav) {
    //     this.leftNavType = getCurrentPages().length > 1 ? 'left' : 'home';
    // }
    if (!this.noLeftNav) {
      let pageStack = getCurrentPages();
      this.showBackIcon = pageStack.length > 1;
      this.showHomeIcon = true;
    }
    if (this.homeFlag) {
      this.showHomeIcon = true;
    }
    if (this.noShowHome) {
      this.showHomeIcon = false;
    }
    if (!this.noLeftNav && sysinfo.swanNativeVersion && compareVersion(sysinfo.swanNativeVersion, '2.28.0') >= 0 && "h5" === 'swan') {
      // 界面预留左上角back位置 home 增加一个left空白占位符 且权重最高 无视其他一切影响
      this.leftBlockFlag = true;
    }
    let needCheck = false;
    {
      // h5有相应cookie时再打接口检查，减少无效请求
      const cookie = document.cookie || '';
      needCheck = cookie.indexOf('orp_preview=1') !== -1 && cookie.indexOf('pandora_preview=1') !== -1;
    }
    // 如果本地有预览机环境标记，择检查下是否为预览机环境（正常只有内部用户才可能有）
    if (needCheck) {
      checkPreview().then(isPreview => {
        // 预览机环境则设置提醒
        if (isPreview) {
          this.isPreview = true;
        }
        // 非预览机环境清除标记
        else {
          this.$api.removeStorageSync(LVLIN_PREVIEW_ENV_RECORD);
        }
      });
    }
  },
  methods: {
    leftNavTo(type) {
      if (!type) {
        return;
      }
      log.send({
        serverId: 16139,
        area: `top-bar-${type}-btn`,
        action: 'click'
      });
      // 左侧跳转
      switch (type) {
        case 'home':
          let types = 'relaunch';
          if (this.listenHome === '1') {
            types = 'switch';
          }
          nav({
            url: '/pages/home/index?vn=law',
            type: types
          });
          break;
        case 'left':
          if (this.listenBack === '1') {
            // listenBack为1，则冒泡点击事件到父组件处理
            this.$emit('handleBack');
          } else {
            nav({
              type: 'back'
            });
          }
          break;
        case 'local':
          log.send({
            serverId: 16139,
            area: 'regional_click',
            action: 'click'
          });
          nav({
            url: '/pages/cityList/index?vn=law'
          });
          break;
        default:
          nav({
            url: '/pages/home/index?vn=law',
            type: 'relaunch'
          });
      }
    },
    goRegulationList() {
      ubcClickInit({
        page: 'regulations',
        value: 'regulations-bar-listicon-clk'
      });
      this.$emit('goRegulationList');
    },
    goSetPreview() {
      nav({
        url: '/pages/setPreview/index'
      });
    }
  }
};
</script>

<style scoped>
.top-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  box-sizing: border-box;
  /* 预览机环境提示（内部用户） */
}
.top-bar .bar {
  align-items: center;
}
.top-bar .bar .title {
  width: 50%;
  font-size: 0.18rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: PingFangSC-Medium;
  text-align: center;
  color: #333;
  font-weight: 600;
}
.top-bar .bar .bar-left {
  text-align: left;
}
.top-bar .bar .bar-left .icon {
  float: left;
  position: relative;
  top: 1px;
  width: 5.8vw;
  margin-left: 0.2rem;
}
.top-bar .bar .bar-left .leftBlock {
  height: 26px;
}
@media screen and (max-width: 320px) {
  .top-bar .bar .bar-left .icon {
    margin-left: 13px;
  }
}
.top-bar .bar .bar-left .home {
  display: inline-block;
}
.top-bar .bar .bar-left .bar-content-local-info {
  position: relative;
  top: 0;
  font-family: PingFangSC-Regular;
  color: #333;
  padding: 0 16px;
  height: 32px;
  border-radius: 16px;
  justify-content: center;
  align-items: center;
  width: fit-content;
  display: flex;
  box-sizing: border-box;
}
.top-bar .bar .bar-left .bar-content-local-info .bar-content-local-val {
  font-size: 16px;
  line-height: 16px;
  margin-right: 6px;
  color: #1e1f24;
  font-weight: 700;
}
.top-bar .bar .bar-left .bar-content-local-info .iconfont {
  color: #858585;
  font-size: 14px;
}
.top-bar .bar .logo {
  width: 43px;
  height: 20px;
  display: block;
}
.top-bar .bar .title-icons-lvlin {
  display: inline-block;
  color: #3b6fff;
  vertical-align: bottom;
  width: 0.68rem;
  height: 0.21rem;
  border: none;
  border-radius: 0;
  margin-right: 0;
  background: transparent;
}
.top-bar .title-icon {
  display: inline-block;
  height: 20px;
  width: 87px;
  background: url('https://law-smartapp.cdn.bcebos.com/avatar/ask-logo.png') center center no-repeat;
  background-size: 100% 100%;
  color: #3b6fff;
  vertical-align: bottom;
}
.top-bar .trusteeship-title-box {
  display: flex;
  justify-content: center;
  align-items: center;
}
.top-bar .image-box {
  width: 0.24rem;
  height: 0.24rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 50%;
  border: 0.6px solid #dedfe0;
  margin-right: 0.05rem;
}
.top-bar .title-icons {
  width: 0.2rem;
  height: 0.2rem;
  background: #fff;
  border-radius: 50%;
  box-sizing: border-box;
}
.top-bar .title-icons-lvlin {
  width: 0.68rem;
  height: 0.21rem;
  border: none;
  border-radius: 0;
  vertical-align: bottom;
  margin-right: 0;
  background: transparent;
}
.top-bar .top-bar-preview {
  position: absolute;
  z-index: 999999;
  left: 0;
  bottom: 0;
  transform: translateY(50%);
  font-size: 10px;
  color: #fff;
  background: rgba(255, 0, 0, 0.5);
  padding: 0 4px;
  line-height: 14px;
  border-radius: 0 14px 14px 0;
}
.top-bar-border {
  border-bottom: 0.6px solid #dedfe0;
}

</style>
